<av-content-container>
  <div class="col-6 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.network.sections.adapters.title'" icon="settings_ethernet"
      [columns]="adapterColumns" [rows]="adapterRows()"
      [countLabelKey]="'app.device.network.count.adapters_found_suffix'"
      [emptyTextKey]="'app.device.network.empty.adapters'" [pageSize]="5" [trackByKey]="'name'" />
  </div>

  <div class="col-6 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.network.sections.ip_addresses.title'" icon="public"
      [columns]="ipAddressColumns" [rows]="ipAddressRows()"
      [countLabelKey]="'app.device.network.count.ip_addresses_found_suffix'"
      [emptyTextKey]="'app.device.network.empty.ip_addresses'" [pageSize]="5" [trackByKey]="'ipAddress'" />
  </div>

  <div class="col-6 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.network.sections.printers.title'" icon="print" [columns]="printerColumns"
      [rows]="printerRows()" [countLabelKey]="'app.device.network.count.printers_found_suffix'"
      [emptyTextKey]="'app.device.network.empty.printers'" [pageSize]="5" />
  </div>

  <div class="col-6 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.network.sections.shared_drives.title'" icon="folder_shared"
      [columns]="sharedDriveColumns" [rows]="sharedDriveRows()"
      [countLabelKey]="'app.device.network.count.shared_drives_found_suffix'"
      [emptyTextKey]="'app.device.network.empty.shared_drives'" [pageSize]="5" [trackByKey]="'letter'" />
  </div>
</av-content-container>